/** */
import React from 'react';
import { Icon } from 'assets/icons';
import styles from './trend-badge.module.css';

export const TrendBadge = ({ trend, invert = false }) => {
  if (trend === null || trend === undefined) return null;
  const n = Number(trend);
  if (isNaN(n) || n === 0) return null;
  const is_up = n > 0;
  const is_positive = invert ? !is_up : is_up;
  return (
    <span className={is_positive ? styles.trendUp : styles.trendDown}>
      <Icon name={is_up ? 'arrow_up' : 'arrow_down'} width={9} height={9} />
      {Math.abs(n).toFixed(1)}%
    </span>
  );
};
